(ns common.schema.entities.team
  (:require
   [common.schema.option-filters :as option-filters]
   [common.schema.constraints :as constraints]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    [[:team/name
      {:field/data-type             :data.type/text-simple
       :field/default-ord           10
       :field/name-attribute        :team/name

       :field/mandatory             :mandatory/always
       :field/system-required?      true
       :field/system-semantics      su/user-provided-system-required-field-semantics
       :field/lower-case-str?       true
       :field/constraints           {:constraint/mandatory-fn      (fn [field-value _entity-data]
                                                                     (empty? (str field-value)))
                                     :constraint/string-min-length 1
                                     :constraint/unique-tenant-ignore-case
                                     {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                              :team/name
                                                              [:entity.type/team])}}
       :field/default-visibility    {:editor :editor.type/text-simple
                                     :grid   :editor.type/text-simple
                                     :filter :filter.type/text
                                     :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/admin}
       :field/not-clearable?        true
       :field/translations          {:en "Team name"}}]
     [:team/members
      {:field/data-type          :data.type/ref-multi
       :field/default-ord        20
       :value-type               :entity
       :field/entity-types       [:entity.type/account]
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/admin}
       :field/not-importable?    true
       :field/default-visibility {:editor :editor.type/multi-select
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/translations       {:en "Team members"}
       :field/option-filter-fn   option-filters/active-users
       :field/os-filter-terms-fn    (fn [{:keys [] :as _args}]
                                      {"extras.active-user" true})}]
     [:team/modules
      {:field/data-type          :data.type/keyword-multi
       :field/default-ord        21
       :value-type               :keyword
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/admin}
       :field/not-importable?    true
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/translations       {:en "Module access"}}]
     [:team/deny-export-access
      {:field/data-type          :data.type/boolean
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/admin}
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/none
                                  :filter :filter.type/none
                                  :field-visibility :in-use}
       :field/translations       {:en "Export access"}}]]
    (su/boolean-field :team/read-only-team?
                      "Read only permissions?"
                      {:default-field-visibility :in-use
                       :authorization su/access-admin-user})
    (su/keyword-multi-field :team/accessible-activities
                            "Accessible activity events"
                            nil
                            {:authorization su/access-admin-user})
    (su/text-edn-field :team/mcp-tool-permissions
                       "MCP tool permissions"
                       {:authorization su/access-admin-user}))))
